export interface GrabAreaItem {
  areaId: number;
  areaName: string;
  countryID: number;
  layer: string;
}

export enum GrabAreaMode {
  AREA_NAME = 'Area Name',
  AREA_IDS = 'Area IDs',
  HIERARCHY = 'Hierarchy',
}

export const GET_GRAB_AREA_DEFAULT_PAGE_SIZE = 10;
